export const initialAbility = [
  {
    action: '',
    subject: ''
  }
]

export const _ = undefined
